module.exports = __webpack_public_path__ + "static/media/m1_sf_8.b6c2f004.png";